import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      // Order of how language is detected
      order: ['localStorage', 'querystring', 'navigator', 'htmlTag', 'cookie', 'sessionStorage'],
      // Where to cache the detected language
      caches: ['localStorage'],
    },
    // backend: { // If using i18next-http-backend to load translations from /public/locales
    //   loadPath: '/locales/{{lng}}/{{ns}}.json',
    // },
    // resources is an alternative if you want to bundle translations
    resources: {
      en: {
        translation: {
          home: "Home",
          events: "Events",
          organization: "Organizations",
          projects: "Projects",
          reporting: "Reporting",
          donate: "Donate",
          home_page_title: "Home Page",
          events_page_title: "Upcoming Events",
          organization_page_title: "Organization Page",
          projects_page_title: "Our Projects",
          reporting_page_title: "Reporting Page",
          donate_page_title: "Donate Page",
          donation_content_placeholder: "Information about how to donate and a donation form will be displayed here soon.",

          // New Home Page Keys
          home_welcome_title: "Welcome!",
          home_branch_info: "",
          home_tel: "Tel: 212-777-1336",
          home_fax: "Fax: 212-777-2063",
          home_association_title: "\"Selfreliance\" Association of Ukrainian Americans",
          home_association_description: "The \"Selfreliance\" Association of Ukrainian Americans was established in 1947 and became a center of initiative for the establishment of key institutions of the Ukrainian American community: schools, choirs, credit unions, museums, cultural, and press and media establishments. Its activities include social, cultural, and educational and the organization's initiatives pushed the formation of a strong, cooperative Ukrainian diaspora in the United States. \"Selfreliance\" is actively working with other nonprofits to provide necessary support and aid to civilians impacted by the war in Ukraine. Together with our community, we work towards a brighter future for Ukrainians here, in New York, and back in Ukraine.",
          home_mission_title: "Mission",
          home_mission_description: "We thrive to support our community with resources in the areas of social, cultural education, humanitarian needs, legal advice and more!",
          home_mission_paragraph: "Our association works for the preservation, promotion and awareness of Ukrainian current events, history, people, language, and culture. Our events include fundraisers, exhibitions, social clubs, and cultural events as well as seminars, consultations and networking events open to everyone in the community with guest speakers and the community sharing their experiences. Our services are open to people of all ages!",
          home_activities_title: "Main activities",
          home_activity_cultural_title: "Cultural and educational work",
          home_activity_cultural_desc: "Ukrainian schools, museums, art groups, choirs",
          home_activity_identity_title: "Preservation of national identity",
          home_activity_identity_desc: "Organization of cultural events, festivals, celebration of national holidays",
          home_activity_lobbying_title: "Lobbying of Ukrainian interests",
          home_activity_lobbying_desc: "Cooperation with American political institutions",

          // Footer Keys
          footer_org_status: "Selfreliance is a 501(c)(3) US organization. Donations are tax-deductible to the extent allowed by law.",
          footer_copyright: "© {{year}} Selfreliance. All Rights Reserved.",

          // New Event Page Keys
          loading_events: "Loading events...",
          error_loading_events: "Error loading events: ",

          // Event specific translations
          no_events_available: "No events scheduled at the moment.",
          event_time_label: "Time:",
          event_place_label: "Place:",
          event_hosted_by_label: "Hosted by:",
          event_more_info_button: "More Info",
          filter_by_organization_label: "Filter by Organization:",
          all_organizations_label: "All Organizations",
          no_events_match_filters: "No events match the current filters.",
          filter_by_date_label: "Filter by Date:",
          date_filter_all: "All Dates",
          date_filter_upcoming: "Upcoming Events",
          date_filter_past: "Past Events",
          view_button_list: "List",
          view_button_grid: "Grid",
          view_button_calendar: "Calendar",
          view_button_map: "Map",
          calendar_view_placeholder: "Calendar view coming soon!",
          map_view_placeholder: "Map view coming soon!",

          event_name_1: "Charity Gala Dinner",
          event_place_1: "Grand Ballroom, Downtown",
          event_desc_1: "An evening of elegance to support our causes. Join us for dinner, auctions, and inspiring stories.",
          event_image_alt_1: "Elegant dinner setting at Charity Gala",

          event_name_2: "Community Workshop: Sustainability",
          event_place_2: "Community Center, Green Park",
          event_desc_2: "Learn about sustainable living practices and how you can make a difference in your community.",
          event_image_alt_2: "People participating in a workshop",

          event_name_3: "Art for Hope Exhibition",
          event_place_3: "City Art Gallery",
          event_desc_3: "Discover powerful art pieces created by local artists, with proceeds supporting our projects.",
          event_image_alt_3: "Art pieces displayed in a gallery",

          // Donate Page Keys (replacing/extending donation_content_placeholder)
          donate_intro_title: "Support Our Mission",
          donate_intro_text1: "Your generous contribution empowers us to continue our vital work in the community, supporting cultural initiatives, educational programs, and providing essential aid.",
          donate_intro_text2: "Every donation, no matter the size, makes a significant impact. Join us in making a difference.",
          donate_options_title: "Choose Your Way to Give",
          donate_option_onetime_title: "One-Time Gift",
          donate_option_onetime_desc: "Make a single, impactful donation today to support our immediate needs and ongoing projects.",
          donate_button_onetime: "Give Once",
          donate_option_monthly_title: "Monthly Support",
          donate_option_monthly_desc: "Become a sustaining partner with a recurring monthly donation, providing consistent support for our long-term goals.",
          donate_button_monthly: "Give Monthly",
          donate_option_program_title: "Sponsor a Program",
          donate_option_program_desc: "Direct your support to a specific program or initiative that resonates with you, such as education, cultural heritage, or community aid.",
          donate_button_program: "Learn More",
          donate_cta_title: "Make Your Impact Today",
          donate_cta_text: "Ready to make a difference? Your contribution is secure and deeply appreciated.",
          donate_now_button: "Donate Now",
          donate_other_ways_title: "Other Ways to Give",
          donate_other_ways_text: "Interested in other ways to support us, such as through mail, donor-advised funds, or corporate sponsorships? Please contact us for more information.",

          // Organization Page specific translations
          no_organizations_available: "No organizations to display at the moment.",
          org_focus_label: "Focus:",
          visit_website_label: "Visit Website",

          // Projects Page specific translations
          controls_placeholder_text: "Filter, Search, and Pagination controls will be here.",
          no_projects_available: "No projects to display at the moment.",
          no_projects_match_filters: "No projects match the current filters.",
          project_status_label: "Status:",
          filter_by_status_label: "Filter by Status:",
          all_statuses_label: "All Statuses",
          search_projects_label: "Search Projects:",
          search_placeholder: "Enter project name or keyword...",
          pagination_previous: "Previous",
          pagination_next: "Next",
          pagination_page_info: "Page {{currentPage}} of {{totalPages}}",
          items_per_page_label: "Items per page:",
          events_page_description: "Explore our upcoming and past events. Find details about community gatherings, workshops, and celebrations.",

          // App-wide keys
          selfreliance_logo_alt: "Selfreliance Logo",
          selfreliance_name: "Selfreliance",
          logout: "Logout",
          login: "Login",
          ukrainian_flag_heart_alt: "Ukrainian flag heart",
          loading: "Loading..."
        }
      },
      uk: {
        translation: {
          home: "Головна",
          events: "Події",
          organization: "Організації",
          projects: "Проекти",
          reporting: "Звітність",
          donate: "Підтримати",
          home_page_title: "Головна сторінка",
          events_page_title: "Майбутні Події",
          organization_page_title: "Сторінка організацій",
          projects_page_title: "Сторінка проектів",
          reporting_page_title: "Сторінка звітності",
          donate_page_title: "Сторінка підтримки",
          donation_content_placeholder: "Інформація про те, як зробити внесок, та форма для пожертв будуть розміщені тут незабаром.",

          // New Home Page Keys (Ukrainian)
          home_welcome_title: "Ласкаво просимо!",
          home_branch_info: "Нью-Йоркський відділ Асоціації американських українців 'Самопоміч', спонсор Федеральної кредитної спілки 'Самопоміч Нью-Йорк'",
          home_tel: "Тел: 212-777-1336",
          home_fax: "Факс: 212-777-2063",
          home_association_title: "Асоціація українців Америки «Самопоміч»",
          home_association_description: "Асоціація українців Америки «Самопоміч» була заснована в 1947 році і стала центром ініціативи зі створення ключових інституцій українсько-американської громади: шкіл, хорів, кредитних спілок, музеїв, культурних, прес- та медійних установ. Її діяльність охоплює соціальну, культурну та освітню сферу, а ініціативи організації сприяли формуванню сильної, знуртованої української діаспори у Сполучених Штатах. «Самопоміч» активно співпрацює з іншими некомерційними організаціями, щоб надати необхідну підтримку та допомогу цивільному населенню, яке постраждало від війни в Україні. Разом з нашою громадою ми працюємо над кращим майбутнім для українців тут, у Нью-Йорку та в Україні.",
          home_mission_title: "Місія",
          home_mission_description: "Ми прагнемо підтримувати нашу громаду ресурсами у сферах соціальної та культурної освіти, гуманітарних потреб, юридичних консультацій та інших!",
          home_mission_paragraph: "Наша асоціація працює над збереженням, популяризацією та підвищенням обізнаності про українські сучасні події, історію, людей, мову та культуру. Наші заходи включають збори коштів, виставки, соціальні клуби та культурні заходи, а також семінари, консультації та заходи для спілкування, відкриті для всіх членів громади, де запрошенні спікери та громада діляться своїми досвідами. Наші послуги доступні для людей будь-якого віку!",
          home_activities_title: "Основні види діяльності",
          home_activity_cultural_title: "Культурно-освітня робота",
          home_activity_cultural_desc: "Українські школи, мистецькі колективи, хори",
          home_activity_identity_title: "Збереження національної ідентичності",
          home_activity_identity_desc: "Організація культурних заходів, фестивалів, відзначення національних свят",
          home_activity_lobbying_title: "Лобіювання українських інтересів",
          home_activity_lobbying_desc: "Співпраця з американськими політичними інституціями",

          // Footer Keys (Ukrainian)
          footer_org_status: "'Самопоміч' є організацією 501(c)(3) у США. Пожертви не оподатковуються в межах, дозволених законом.",
          footer_copyright: "© {{year}} Самопоміч. Всі права захищені.",

          // New Event Page Keys (Ukrainian - using English as placeholder)
          loading_events: "Завантаження подій...",
          error_loading_events: "Помилка завантаження подій: ",

          // Donate Page Keys (Ukrainian - using English as placeholder)
          donate_intro_title: "Support Our Mission",
          donate_intro_text1: "Your generous contribution empowers us to continue our vital work in the community, supporting cultural initiatives, educational programs, and providing essential aid.",
          donate_intro_text2: "Every donation, no matter the size, makes a significant impact. Join us in making a difference.",
          donate_options_title: "Choose Your Way to Give",
          donate_option_onetime_title: "One-Time Gift",
          donate_option_onetime_desc: "Make a single, impactful donation today to support our immediate needs and ongoing projects.",
          donate_button_onetime: "Give Once",
          donate_option_monthly_title: "Monthly Support",
          donate_option_monthly_desc: "Become a sustaining partner with a recurring monthly donation, providing consistent support for our long-term goals.",
          donate_button_monthly: "Give Monthly",
          donate_option_program_title: "Sponsor a Program",
          donate_option_program_desc: "Direct your support to a specific program or initiative that resonates with you, such as education, cultural heritage, or community aid.",
          donate_button_program: "Learn More",
          donate_cta_title: "Make Your Impact Today",
          donate_cta_text: "Ready to make a difference? Your contribution is secure and deeply appreciated.",
          donate_now_button: "Donate Now",
          donate_other_ways_title: "Other Ways to Give",
          donate_other_ways_text: "Interested in other ways to support us, such as through mail, donor-advised funds, or corporate sponsorships? Please contact us for more information.",

          // Event specific translations (Ukrainian)
          no_events_available: "На даний момент запланованих подій немає.",
          event_time_label: "Час:",
          event_place_label: "Місце:",
          event_hosted_by_label: "Організатори:",
          event_more_info_button: "Детальніше",
          filter_by_organization_label: "Фільтр за організатором:",
          all_organizations_label: "Всі організатори",
          no_events_match_filters: "Жодна подія не відповідає поточним фільтрам.",
          filter_by_date_label: "Фільтр за датою:",
          date_filter_all: "Всі дати",
          date_filter_upcoming: "Майбутні події",
          date_filter_past: "Минулі події",
          view_button_list: "Список",
          view_button_grid: "Сітка",
          view_button_calendar: "Календар",
          view_button_map: "Мапа",
          calendar_view_placeholder: "Вигляд календаря незабаром!",
          map_view_placeholder: "Вигляд мапи незабаром!",

          event_name_1: "Благодійний Гала-Вечір",
          event_place_1: "Гранд Болрум, Центр міста",
          event_desc_1: "Вечір елегантності для підтримки наших цілей. Приєднуйтесь до нас на вечерю, аукціони та надихаючі історії.",
          event_image_alt_1: "Елегантне сервірування столу на Благодійному Гала-Вечорі",

          event_name_2: "Семінар для громади: Сталий розвиток",
          event_place_2: "Громадський центр, Зелений парк",
          event_desc_2: "Дізнайтеся про практики сталого життя та як ви можете змінити на краще свою громаду.",
          event_image_alt_2: "Люди беруть участь у семінарі",

          event_name_3: "Виставка \"Мистецтво заради Надії\"",
          event_place_3: "Міська художня галерея",
          event_desc_3: "Відкрийте для себе потужні мистецькі твори місцевих художників. Кошти від продажу підуть на підтримку наших проектів.",
          event_image_alt_3: "Мистецькі твори, виставлені в галереї",

          // Organization Page specific translations (Ukrainian)
          no_organizations_available: "На даний момент організацій для відображення немає.",
          org_focus_label: "Напрямок:",
          visit_website_label: "Відвідати вебсайт",

          // Projects Page specific translations (Ukrainian)
          controls_placeholder_text: "Елементи керування фільтрами, пошуком та пагінацією будуть тут.",
          no_projects_available: "Проектів для відображення на даний момент немає.",
          no_projects_match_filters: "Жоден проект не відповідає поточним фільтрам.",
          project_status_label: "Статус:",
          filter_by_status_label: "Фільтрувати за статусом:",
          all_statuses_label: "Всі статуси",
          search_projects_label: "Пошук проектів:",
          search_placeholder: "Введіть назву проекту або ключове слово...",
          pagination_previous: "Попередня",
          pagination_next: "Наступна",
          pagination_page_info: "Сторінка {{currentPage}} з {{totalPages}}",
          items_per_page_label: "Елементів на сторінці:",
          events_page_description: "Переглядайте наші майбутні та минулі події. Знаходьте деталі про громадські зібрання, семінари та святкування.",

          // App-wide keys
          selfreliance_logo_alt: "Логотип Самопомочі",
          selfreliance_name: "Самопоміч",
          logout: "Вийти",
          login: "Увійти",
          ukrainian_flag_heart_alt: "Серце з українським прапором",
          loading: "Завантаження..."
        }
      }
    }
  });

export default i18n;
